"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInteger = exports.findIndex = void 0;

var _polyfills = require("./polyfills");

var findIndex = function findIndex(array, predicate) {
  var firstIndex = null;
  array.forEach(function (item, index) {
    if (predicate(item) && firstIndex === null) {
      firstIndex = index;
    }
  });
  return firstIndex;
};

exports.findIndex = findIndex;

var isInteger = function isInteger(value) {
  return (0, _polyfills.NumberIsInteger)(value);
};

exports.isInteger = isInteger;